/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Query, Mutation } from 'react-apollo';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import Card from 'components/Card/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardBody from 'components/Card/CardBody.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import Pathology from 'components/Pathologies/Pathology';
import PathologyForm from 'components/Pathologies/PathologyForm';
import SimpleBasicDialog from 'components/Dialog/SimpleBasicDialog';
import { GET_PATIENT_PATHOLOGIES, UPSERT_PATIENT_PATHOLOGY, DELETE_PATIENT_PATHOLOGY } from 'graphql/queries';
import { withTranslation } from 'react-i18next';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    minWidth: 100,
    maxWidth: 200,
  },
  birthday: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  studies: {
    width: 180,
  },
  actions: {
    display: 'flex',
  },
});

class Pathologies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      index: null,
    };
  }

  handleAddPathology = () => {
    this.setState({
      open: true,
      index: null,
    });
  };

  handleUpdatePatientPathology = (e) => {
    this.setState({
      open: true,
      index: e.currentTarget.dataset.index,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { classes, id, t } = this.props;

    return (
      <div>
        <Button variant="outlined" color="primary" onClick={this.handleAddPathology}>
          {t('VPatient_AddCondition')}
        </Button>

        <Query query={GET_PATIENT_PATHOLOGIES} variables={{ id }} fetchPolicy="cache-and-network">
          {({ loading, error, data }) => {
            if (loading) return 'Loading...';
            if (error) return `Error! ${error.message}`;

            return (
              <div>
                <SimpleBasicDialog
                  title={t('VPatient_Conditions')}
                  content={
                    <PathologyForm
                      id={id}
                      mutation={UPSERT_PATIENT_PATHOLOGY}
                      onClose={this.handleClose}
                      pathologies={data.getPatient.pathologies}
                      index={this.state.index}
                    />
                  }
                  onClose={this.handleClose}
                  open={this.state.open}
                />

                <GridContainer spacing={40}>
                  {data.getPatient.pathologies.map((p) => (
                    <GridItem key={p.name} sm={6} md={4} lg={4}>
                      <Card className={classes.card}>
                        <CardActionArea onClick={this.handleUpdatePatientPathology} data-index={p.name}>
                          <CardHeader
                            title={<Typography noWrap>{t(p.name)}</Typography>}
                            subheader={p.date}
                            data-_id={id}
                          />
                          <CardBody>
                            <Pathology pathology={JSON.parse(p.content)} />
                          </CardBody>
                        </CardActionArea>
                        <CardActions className={classes.delete}>
                          <Mutation mutation={DELETE_PATIENT_PATHOLOGY}>
                            {(deletePatientPathology) => (
                              <div>
                                <IconButton
                                  aria-label="Delete"
                                  onClick={() => {
                                    deletePatientPathology({ variables: { id, slug: p.slug } });
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </div>
                            )}
                          </Mutation>
                        </CardActions>
                      </Card>
                    </GridItem>
                  ))}
                </GridContainer>
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

Pathologies.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(Pathologies));
